import { render, staticRenderFns } from "./OrderArrivalDetail.vue?vue&type=template&id=576a37cd&scoped=true&"
import script from "./OrderArrivalDetail.vue?vue&type=script&lang=js&"
export * from "./OrderArrivalDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderArrivalDetail.vue?vue&type=style&index=0&id=576a37cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576a37cd",
  null
  
)

export default component.exports